<div
  class="card"
  data-testid="selecthor-admin-registerProvider"
  *transloco="let t; prefix: 'selecthorAdmin.registerProvider'"
>
  <p-fluid>
    <div class="flex items-center justify-center w-full">
      <div class="w-full max-w-4xl rounded-xl">
        <div class="card flex flex-col gap-4 mt-3">
          <div class="font-semibold text-2xl">{{ t('createProviderAccount') }}</div>
          {{ t('enterPersonalData') }}
          <form
            [formGroup]="form"
            (ngSubmit)="onSubmit()"
            class="flex flex-col gap-4"
            data-testid="admin-provider-registration-form"
          >
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <app-form-field
                id="hrToolProviderDirectusId"
                fieldName="hrToolProviderDirectusId"
                label="common.hrToolProviderDirectusId"
                type="dropdownSelect"
                [dropDownOptions]="hrToolProvidersOptions()"
              ></app-form-field>

              <app-form-field
                id="authMode"
                fieldName="authMode"
                label="common.authMode"
                type="dropdownSelect"
                [dropDownOptions]="authModeOptions"
                data-testid="authMode-select"
              ></app-form-field>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <app-form-field
                id="firstName"
                fieldName="firstName"
                label="common.firstName"
              ></app-form-field>

              <app-form-field
                id="lastName"
                fieldName="lastName"
                label="common.lastName"
              ></app-form-field>
            </div>

            <div class="grid grid-cols-1 gap-4">
              <app-form-field
                id="email"
                fieldName="email"
                label="common.email"
                type="email"
                placeholder="beispiel@email.com"
              ></app-form-field>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="md:col-span-2">
                <app-form-field
                  id="street"
                  fieldName="street"
                  label="common.street"
                ></app-form-field>
              </div>

              <app-form-field
                id="houseNumber"
                fieldName="houseNumber"
                label="common.houseNumber"
              ></app-form-field>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <app-form-field
                id="zipCode"
                fieldName="zipCode"
                label="common.zipCode"
              ></app-form-field>

              <app-form-field id="city" fieldName="city" label="common.city"></app-form-field>

              <div class="flex flex-col gap-2">
                <label for="countryCode">{{ 'common.country' | transloco }}</label>
                <app-country-select
                  formControlName="countryCode"
                  [placeholder]="'common.country' | transloco"
                  testId="countryCode-input"
                ></app-country-select>
                @if (form.get('countryCode')?.invalid && form.get('countryCode')?.touched) {
                  <p-message
                    severity="error"
                    variant="simple"
                    size="small"
                    data-testid="countryCode-error"
                  >
                    {{ 'account.validation.requiredField' | transloco }}
                  </p-message>
                }
              </div>
            </div>

            <p-divider></p-divider>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <app-form-field
                id="subject"
                fieldName="subject"
                label="common.subject"
                type="text"
              ></app-form-field>

              <app-form-field
                id="templateLanguage"
                fieldName="templateLanguage"
                label="common.language"
                type="dropdownSelect"
                [dropDownOptions]="languageOptions()"
                data-testid="language-select"
              ></app-form-field>
            </div>

            <div class="grid grid-cols-1 gap-4">
              <app-rich-text-editor
                key="selecthorAdmin_providerInvitation_mail"
                [showSaveButton]="false"
                [showLabel]="false"
                [overrideLanguage]="selectedTemplateLanguage()"
                (contentChange)="onEmailContentChange($event)"
                (templateLoaded)="onTemplateLoaded($event)"
                (contentReset)="onContentReset($event)"
                data-testid="email-content-editor"
              />
            </div>

            <div class="mt-4">
              <p-button
                [disabled]="isSubmitDisabled()"
                data-testid="submit-button"
                type="submit"
                [label]="'common.sendInvitation' | transloco"
                [loading]="submitting"
              ></p-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </p-fluid>
</div>
